import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Hyperlink } from "@ebsco-ui/ebsco-ui";
import { EBSCO_URLS } from "../../../../constants";
import AccountBenefit from "../account-benefit";
import messages from "./account-benefits-messages";
import syncIcon from "./ic_sync.svg";
import downloadIcon from "./ic_ebooks.svg";
import projectsIcon from "./ic_projects.svg";
import saveIcon from "./ic_save.svg";
import "./account-benefits.scss";

const block = "account-benefits";

const AccountBenefits = ({ intl: { formatMessage } }) => (
  <div className={block}>
    <h2 className={`${block}__header`}>
      <FormattedMessage {...messages.accountBenefits} />
    </h2>
    <AccountBenefit
      imgSrc={syncIcon}
      title={formatMessage(messages.syncWithMobileApp)}
      description={formatMessage(messages.syncWithMobileAppDescription)}
    >
      <ul className={`${block}__mobile-links`}>
        <li className={`${block}__mobile-link`}>
          <Hyperlink href={EBSCO_URLS.IOS_APP} target="_blank">
            {formatMessage(messages.iOS)}
          </Hyperlink>
        </li>
        <li className={`${block}__mobile-link`}>
          <Hyperlink href={EBSCO_URLS.ANDROID_APP} target="_blank">
            {formatMessage(messages.android)}
          </Hyperlink>
        </li>
      </ul>
    </AccountBenefit>
    <AccountBenefit
      imgSrc={downloadIcon}
      title={formatMessage(messages.downloadEBooks)}
      description={formatMessage(messages.downloadEBooksDescription)}
    />
    <AccountBenefit
      imgSrc={projectsIcon}
      title={formatMessage(messages.createProjects)}
      description={formatMessage(messages.createProjectsDescription)}
    />
    <AccountBenefit
      imgSrc={saveIcon}
      title={formatMessage(messages.saveYourResearch)}
      description={formatMessage(messages.saveYourResearchDescription)}
    />
  </div>
);

export { AccountBenefits };
export default injectIntl(AccountBenefits);
